import { render, staticRenderFns } from "./CarCoverages.vue?vue&type=template&id=c6c30730&"
import script from "./CarCoverages.vue?vue&type=script&lang=js&"
export * from "./CarCoverages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports